
const API = {
    address : 'https://digitalclientlog.com:444/api',
    /*address : 'http://localhost:8080/api',*/
    key : 'PjqJi7pm[ywAYyp(Hn37Xieh?o!ZaY#5n%h+_]rWQZEfc!crW6Ce_#uvhTwmHGGL_(fpa=Aej8x23_6x',
    subdomains : ['eszii', 'tryme', 'ures']
}

export default API;